import { Shop } from "../../shop/models/Shop";

export interface PromotionCreateForm {
  name: string;
  shop?: Shop;
  startDate?: string | Date;
  endDate?: string | Date;
  promotionGroup: PromotionGroupForm;
  inuse: boolean;
}

export interface PromotionGroupForm {
  id?: number;
  channelsSelected: number[];
  conditionType: string;
  conditionItemGroups: PromotionItemGroupForm[];
  promotionItemGroups: PromotionItemGroupForm[];
  promotionConditionPrices: PromotionConditionPriceForm[];
  orderLimit: number;
  orderItemLimit: boolean;
  orderItemLimitAmount: number | null;
  promotionHold: boolean;
  deletedConditionItemGroupsId?: number[];
  deletedPromotionItemGroupsId?: number[];
  deletedPromotionConditonPricesId?: number[];
}

export interface PromotionItemGroupForm {
  id?: number;
  items: PromotionItemForm[];
  deletedItemsId?: number[];
}

export enum PromotionItemStatus {
  Init,
  Loading,
  Success,
  Fail
}

export interface PromotionItemForm {
  id?: number;
  name: string;
  sku: string;
  quantity: number;
  status: PromotionItemStatus;
}

export interface PromotionConditionPriceForm {
  id?: number;
  price: number;
  promotionItemGroups: PromotionItemGroupForm[];
  deletedPromotionGroupsId?: number[];
}
